const config = {
  //baseURL: "http://localhost:8006/api",
  baseURL: "https://jaeval.com/api",
  crossOrigin: null,
  basename: '/'
};
export default config;
